import { Component, Input, OnInit } from '@angular/core';

import { isFunction } from './toast.utils';
import { ToastService, ToastData, ToastConfig } from './toast.service';


@Component({
  selector: 'toast-container',
  template: `
    <div id="toast-container" [ngClass]="[position]">
        <toast *ngFor="let toast of toasts" [toast]="toast" (closeToast)="closeToast(toast)"></toast>
    </div>`
})
export class ToastContainerComponent implements OnInit {
  /**
   * Set of constants defines position of Toasts on the page.
   */
  static POSITIONS: Array<String> = ['bottom-right', 'bottom-left', 'top-right', 'top-left', 'top-center',
                    'bottom-center', 'center-center'];

  // The storage for toasts.
  toasts: Array<ToastData> = [];

  private _position: string = '';

  @Input() set position(value: string) {
    if (value) {
      let notFound = true;
      for (let i = 0; i < ToastContainerComponent.POSITIONS.length; i++) {
        if (ToastContainerComponent.POSITIONS[i] === value) {
          notFound = false;
          break;
        }
      }
      if (notFound) {
        // Position was wrong - clear it here to use the one from config.
        value = this.config.position;
      }
    } else {
      value = this.config.position;
    }
    this._position = 'toast-position-' + value;
  }

  get position(): string {
    return this._position;
  }

  constructor(private config: ToastConfig, private toastService: ToastService) {
    // Initialise position
    this.position = '';
  }

  /**
   * `ngOnInit` is called right after the directive's data-bound properties have been checked for the
   * first time, and before any of its children have been checked. It is invoked only once when the
   * directive is instantiated.
   */
  ngOnInit(): any {
    // We listen our service to recieve new toasts from it
    this.toastService.getToasts().subscribe((toast: ToastData) => {
      // If we've gone over our limit, remove the earliest
      // one from the array
      if (this.toasts.length >= this.config.limit) {
        this.toasts.shift();
      }
      // Add toast to array
      this.toasts.push(toast);
      //
      // If there's a timeout individually or globally,
      // set the toast to timeout
      if (toast.timeout) {
        this._setTimeout(toast);
      }
    });
    // We listen clear all comes from service here.
    this.toastService.getClear().subscribe((id: number) => {
        if (id) {
            this.clear(id);
        } else {
            // Lets clear all toasts
            this.clearAll();
        }
    });
  }

  /**
   * Event listener of 'closeToast' event comes from ToastContainerComponent.
   * This method removes ToastComponent assosiated with this Toast.
   */
  closeToast(toast: ToastData) {
    this.clear(toast.id);
  }

  /**
   * Clear individual toast by id
   * @param id is unique identifier of Toast
   */
  clear(id: number) {
    if (id) {
      this.toasts.forEach((value: any, key: number) => {
        if (value.id === id) {
          if (value.onRemove && isFunction(value.onRemove)) {
            value.onRemove.call(this, value);
          }
          this.toasts.splice(key, 1);
        }
      });
    } else {
      throw new Error('Please provide id of Toast to close');
    }
  }

  /**
   * Clear all toasts
   */
  clearAll() {
    this.toasts.forEach((value: any, key: number) => {
      if (value.onRemove && isFunction(value.onRemove)) {
        value.onRemove.call(this, value);
      }
    });
    this.toasts = [];
  }

  /**
   * Custom setTimeout function for specific setTimeouts on individual toasts.
   */
  private _setTimeout(toast: ToastData) {
    window.setTimeout(() => {
      this.clear(toast.id);
    }, toast.timeout);
  }
}



// WEBPACK FOOTER //
// ./src/common/toasts/toast-container.component.ts